import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            内容分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-4">
            探索精彩内容
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            按分类浏览，快速找到您感兴趣的内容与教程
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${category.icon} text-xl text-accent-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">{category.name}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{category.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{category.articleCount} 篇文章</span>
                <span className="text-xs text-accent-600 font-medium group-hover:translate-x-1 transition-transform duration-200 inline-flex items-center gap-1">
                  浏览分类
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}